module.exports = __webpack_public_path__ + "static/media/sommarlager_small.ecfe03c0.jpg";